import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CommentSentimentsAndEmotionsFilter from './comment-filter/CommentSentimentsAndEmotionsFilter';
import CommentSarcasmScoreRangeFilter from './comment-filter/CommentSarcasmScoreRangeFilter';
import RelevanceFilter from './comment-filter/RelevanceFilter';
import { RELEVANT_OPTION_VALUE } from './comment-filter/constants/RelevanceFilterConstants';

export class CommentFilter extends Component {
    static propTypes = {
        commentFilterItems: PropTypes.array.isRequired,
        handleCommentsFilter: PropTypes.func.isRequired,
        minimumSarcasmScore: PropTypes.number.isRequired,
        maximumSarcasmScore: PropTypes.number.isRequired,
        setCommentsAndTweetsSarcasmScoreFilter: PropTypes.func.isRequired,
        relevanceFilterOption: PropTypes.string.isRequired,
        handleRelevanceFilterSelection: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            isCommentFilter: false,
            minimumSarcasmScore: 0,
            maximumSarcasmScore: 100,
            relevanceFilterOption: RELEVANT_OPTION_VALUE
        };
        this.wrapperRef = React.createRef();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentDidMount() {
      this.setState({
        minimumSarcasmScore: this.props.minimumSarcasmScore,
        maximumSarcasmScore: this.props.maximumSarcasmScore,
        relevanceFilterOption: this.props.relevanceFilterOption
      });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        minimumSarcasmScore: nextProps.minimumSarcasmScore,
        maximumSarcasmScore: nextProps.maximumSarcasmScore,
        relevanceFilterOption: nextProps.relevanceFilterOption
      });
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }

    toggleIfCommentFilterIsActive= () => {
        this.setState(prevState => {
          return { isCommentFilter: !prevState.isCommentFilter };
        });
    }

    handleClickOutside = event => {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.setState({isCommentFilter: false });
        }
    }

    render() {
        const {
            isCommentFilter,
            minimumSarcasmScore,
            maximumSarcasmScore,
            relevanceFilterOption
        } = this.state;

        return (
          <div
            className={`input-container ${isCommentFilter ? 'active' : ''}`}
            ref={this.wrapperRef}
          >
            <div
              className="toggle-btn"
              onClick={() => this.toggleIfCommentFilterIsActive()}
            >
              <i className="la la-filter icon" />
            </div>
            {isCommentFilter && (
              <div className="comments-filter">
                <CommentSentimentsAndEmotionsFilter 
                  commentFilterItems={this.props.commentFilterItems}
                  handleCommentsFilter={this.props.handleCommentsFilter}
                />
                <CommentSarcasmScoreRangeFilter
                  minimumSarcasmScore={minimumSarcasmScore}
                  maximumSarcasmScore={maximumSarcasmScore}
                  setCommentsAndTweetsSarcasmScoreFilter={this.props.setCommentsAndTweetsSarcasmScoreFilter}
                />
                <RelevanceFilter 
                  relevanceFilterOption={relevanceFilterOption}
                  handleRelevanceFilterSelection={this.props.handleRelevanceFilterSelection}
                  toggleIfCommentFilterIsActive={this.toggleIfCommentFilterIsActive}
                />
              </div>
            )}
            </div>
        )
    }
};

export default CommentFilter;


// WEBPACK FOOTER //
// ./src/features/home/components/CommentFilter.js